import _get from 'lodash/get';

export const officialIdentificationFormatter = (values) => ({
  uuid: _get(values, 'uuid', ''),
  identityKey: _get(values, 'identificationCode', ''),
  identityTypeUuid: _get(values, 'identificationType', ''),
  issuedYear: _get(values, 'emissionYear', ''),
  validityYear: _get(values, 'validity', ''),
});
